module.exports = __webpack_public_path__ + "img/evil.7f97bc27.png";